<form>
  <div class="c-forgot-page" fxLayout="column" fxLayoutAlign="center center">
    <div class="c-login-logo">
      <img [src]="logoURL ? logoURL : 'assets/images/logo-brand-pmc.svg'" />
    </div>
    <div class="c-forgot-box">
      <label class="u-margin-bottom-15">{{ "forgot_password.header" | translate }}</label>
      <button
        mat-button
        mat-flat-button
        color="primary"
        class="c-forgot-button u-margin-top-15 u-margin-bottom-15"
        routerLink="email"
      >
        {{ "forgot_password.btn_email" | translate }}
      </button>
      <button
        mat-button
        mat-flat-button
        color="primary"
        class="c-forgot-button "
        routerLink="secret-word"
      >
        {{ "forgot_password.btn_secret_word" | translate }}
      </button>
    </div>
  </div>
</form>
